<template>
    <div class="default-form">
        <div class="row">
            <form-field
                v-for="field in fields"
                :key="field.id"
                :index="field.id"
                :field="field"
            ></form-field>
        </div>
        <button v-on:click="$emit('submit', $event)" :class="submitClass" :disabled="disableSubmit">
            <span>{{submitText}}</span>
                <div v-if="submitted" class="submit-spinner spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
        </button>
        <div class="invalid-input" v-if="errorsExist">Please correct the errors above to submit. Thank you.</div>
        <div class="invalid-input" v-if="submissionError">{{submissionError}}</div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
  import FormField from './FormField';
  import formMixin from '../mixins/formMixin';

  export default {
    mixins: [formMixin],
    data() {
      return {
        errors: [],
        height: '',
      };
    },
    methods: {
      ...mapMutations('form', { setFormId: 'setFormId' }),
      ...mapActions('form', { getForm: 'getForm' }),
    },
    computed: {
      ...mapGetters({
        formErrors: 'fieldsWithErrors',
        userInput: 'response',
      }),
      ...mapGetters('form', [
        'fields',
        'redirect',
        'inline_title',
        'inline_message',
        'submit_text',
        'submissionError'
      ]),
      ...mapState('form', { form: 'form', formId: 'formId', submitted:'submitted' }),
      ...mapState('payments', {stripe: 'stripe', cardLoaded: 'cardLoaded'}),
      submitText() {
          return !this.submit_text ? 'Submit' : this.submit_text;
      }
    },
    components: {
      FormField
    },
  };
</script>
<style>
.submit-spinner.spinner-border {
    margin-left: 1rem;
    display:inline-block;
    border-width:.15rem;
    height:18px;
    width:18px;
    margin-top:-1px;
}
</style>
